// @ts-ignore
import React from 'react';
import { init, makeAppWithCustomComponents } from '@boschebike/dodo/browser-lib';
import { customComponents } from './components';
import { Goose } from './goose';
import { initModals } from './modals/initModals';

const main = () => {
  window['suscribeGooseInitEvent'] = suscribeGooseInitEvent; // prefered way to subscribe to the dodo-ready event
  suscribeGooseInitEvent(() => console.log('goose ready')); // force goose object initialization
  const App = makeAppWithCustomComponents(customComponents)
  init(App);
};

const onDodoReady = (eventHandler: () => void) => {
  initModals();
  // goose will be initialized with the first event
  if(!window['dodo']?.goose) {
    window['dodo']['goose'] = new Goose();
  }
  eventHandler();
}

function suscribeGooseInitEvent(eventHandler: () => void) {
  // if the dodo object doesn't exist we listen the event
  // otherwise the event was already triggered
  if(!window['dodo']) {
    document.getElementsByTagName('html')
    .item(0)?.addEventListener(
      'dodo-ready',
      () => onDodoReady(eventHandler),
      { once: true });
    return
  }
  onDodoReady(eventHandler);
}

main();
